import { SsbEntryPoint } from '../types/enums/SsbEntryPoint.enum';

export const CONDITION_COLORS = {
  include: {
    panelBackground: '#FBFDFF',
    background: '#EFF6FF',
    hoverBackground: '#DBEAFE',
    accent: '#1D4ED8',
    border: '#93C5FD',
  },
  except: {
    panelBackground: '#fdfafa',
    background: '#FEF2F2',
    hoverBackground: '#FEE2E2',
    accent: '#B91C1C',
    border: '#FECACA',
  },
};

export type ConditionVariant = keyof typeof CONDITION_COLORS;

// box-wide traits subtract from the box, so they share the except palette
export function entryPointColors(entryPoint: SsbEntryPoint) {
  return CONDITION_COLORS[entryPoint === SsbEntryPoint.INCLUSION ? 'include' : 'except'];
}
